import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `
    <router-outlet />
  `,
  styles: [],
})
export class App implements OnInit {
  protected readonly title = signal('admin');
  private readonly translateService = inject(TranslateService);

  ngOnInit(): void {
    // Set default language and available languages
    this.translateService.addLangs(['en']);
    this.translateService.setFallbackLang('en');

    // Try to use browser language if available, otherwise use default
    const browserLang = this.translateService.getBrowserLang();
    const langToUse = browserLang && this.translateService.getLangs().includes(browserLang) ? browserLang : 'en';
    this.translateService.use(langToUse);
  }
}
